import React from 'react';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Coloca la rodillera',
    desc: 'Ajusta las correas de velcro a tu medida para un soporte firme y cómodo.',
    image: 'https://cdn.magicpatterns.com/uploads/w4VgjoZJPwGg2QsGKiDHxF/ChatGPT_Image_Mar_14,_2026,_07_51_23_AM.png',
    alt: 'Hombre colocando la rodillera térmica en su rodilla'
  }, {
    num: '2',
    title: 'Conecta el cable USB',
    desc: 'Enchúfalo a un powerbank, laptop o adaptador y elige entre 3 niveles de calor.',
    image: 'https://cdn.magicpatterns.com/uploads/7sU2HPe7PcGpUCeToxmQdB/ChatGPT_Image_Mar_14,_2026,_07_52_12_AM.png',
    alt: 'Mujer conectando la rodillera térmica USB a su laptop'
  }, {
    num: '3',
    title: 'Disfruta el alivio',
    desc: 'Siente cómo el calor terapéutico penetra y alivia el dolor en minutos.',
    image: 'https://cdn.magicpatterns.com/uploads/oeQBGAb4y6yp4g1u1SXHW2/ChatGPT_Image_Mar_14,_2026,_07_51_28_AM.png',
    alt: 'Mujer disfrutando el alivio de la rodillera térmica en casa'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <div className="text-center mb-12" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-120">
            ¿Cómo Funciona?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-121">Tan fácil como 1, 2, 3.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-122">
          {/* Connector line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-blue-100 z-0" data-id="element-123"></div>

          {steps.map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-124">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden mb-4 shadow-md border border-slate-100" data-id="element-125">
                <img src={step.image} alt={step.alt} className="w-full h-full object-cover" data-id="element-126" />
              </div>
              <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mb-4 shadow-lg border-4 border-white -mt-10 relative z-10" data-id="element-127">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-128">
                {step.title}
              </h3>
              <p className="text-slate-600" data-id="element-129">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}